import * as React from "react";
import { PropsWithChildren } from "react";
import Switch from "react-switch";


interface Props  {
    title:string
    layername:string
    applylayerchange: (layername:string,checked:boolean) => void
    checked: boolean
};

interface State  {
    checked: boolean
}

export default class ReactSwitch extends React.Component<PropsWithChildren <Props>,State> {
    constructor(props: Props) {

        super(props);
        this.state = {checked: props.checked};
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(checked: boolean) {

        this.props.applylayerchange(this.props.layername,checked);
        this.setState({checked});
    }

    render() {
        return (
            <label>
                <Switch className="toggleswitches" onChange={this.handleChange} checked={this.state.checked}/>
                <span style={{marginLeft:"3px"}}>{this.props.title}</span>
            </label>
        );
    }
}
